import { Fragment, useState } from 'react';

import Tip, { TipPlacement } from 'bloko/blocks/drop/Tip';
import HoverTip from 'bloko/blocks/drop/Tip/HoverTip';
import Gap from 'bloko/blocks/gap';
import Icon, { IconColor, IconLink, IconScale, IconView } from 'bloko/blocks/icon';

import useTrl from 'hooks/translation/useTrls';

import Table from 'components/Table';

import Spinner from 'components/Admin/Spinner';
import TitlePage from 'components/Admin/TitlePage';
import Filter from 'components/Admin/Translations/Filter';
import TranslationEditModal from 'components/Admin/Translations/TranslationEditModal';
import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

const Translations = () => {
    const { filteredTrls, isLoad } = useSelector((state) => state.translations);
    const [isVisibleEditing, setVisibleEditing] = useState(false);
    const [editableKey, setEditableKey] = useState('');
    const trl = useTrl();

    return (
        <Fragment>
            <TitlePage>{trl('admin.SectionTabs.translations')}</TitlePage>
            <Gap top bottom>
                <Filter />
            </Gap>
            {isLoad ? (
                <Spinner />
            ) : (
                <Table bordered withStripes>
                    <TableBody>
                        {filteredTrls.map(({ key }) => (
                            <TableRow key={key}>
                                <TableCell>{key}</TableCell>
                                <TableCell>
                                    <IconLink
                                        onClick={() => {
                                            setEditableKey(key);
                                            setVisibleEditing(true);
                                        }}
                                    >
                                        <HoverTip
                                            placement={TipPlacement.Top}
                                            render={() => trl('admin.Translations.edit')}
                                            DropElement={Tip}
                                            host={document.body}
                                        >
                                            <Icon
                                                view={IconView.PenSquare}
                                                initial={IconColor.Blue60}
                                                scale={IconScale.Medium}
                                            />
                                        </HoverTip>
                                    </IconLink>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
            <TranslationEditModal
                isVisible={isVisibleEditing}
                setHidden={() => setVisibleEditing(false)}
                editableKey={editableKey}
                resetEditableKey={() => setEditableKey('')}
            />
        </Fragment>
    );
};

export default Translations;
